import React, { useEffect, useState } from 'react';
import axios from '../api/axiosInstance'; // ✅ axios sécurisé
import { useParams } from 'react-router-dom';
import Sidebar from './Sidebar';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Paper,
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import '../css/CompanyDetails.css';

const CompanyDetails = () => {
  const { id } = useParams();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await axios.get(`/societes/${id}`);
        setCompany(response.data);
      } catch (err) {
        setError("Erreur lors de la récupération des détails de la société.");
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, [id]);

  return (
    <Box className="company-details-container">
      <Sidebar />
      <Box className="main-content">
        <Typography variant="h4" gutterBottom>Détails de la société</Typography>

        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : company ? (
          <Paper className="company-details-card" elevation={3}>
            <Typography variant="h5" gutterBottom>{company.nom}</Typography>
            <Typography><strong>SIRET:</strong> {company.siret}</Typography>
            <Typography><strong>Nombre d'utilisateurs:</strong> {company.users?.length || 0}</Typography>

            <Typography variant="h6" mt={3}>Utilisateurs associés :</Typography>
            <List dense>
              {company.users?.length > 0 ? (
                company.users.map((user) => (
                  <ListItem key={user._id}>
                    <ListItemText
                      primary={`${user.firstName || 'Prénom inconnu'} ${user.lastName || 'Nom inconnu'}`}
                      secondary={user.emailAddress || 'Email inconnu'}
                    />
                  </ListItem>
                ))
              ) : (
                <ListItem>
                  <ListItemText primary="Aucun utilisateur associé" />
                </ListItem>
              )}
            </List>
          </Paper>
        ) : (
          <Alert severity="info">Aucune société trouvée.</Alert>
        )}
      </Box>
    </Box>
  );
};

export default CompanyDetails;
